// Translates a `picker.resolveSelection` rejection into the `{ message, link }`
// shape consumers render with <PickerSubmitError />.
//
// Returns null for two cases the consumer should ignore:
//   - archived-collision pivots (picker swaps to PANEL_ARCHIVED internally)
//   - non-status throws (validation errors, "select a customer" etc.) — those
//     are picker-internal flow control, not user-presentable copy.
const parseResolveError = (error) => {
  if (error?.archivedContact) return null
  if (!error?.status) return null
  const message = Array.isArray(error.message)
    ? error.message.join(". ")
    : error.message
  return { message, link: error.link ?? null }
}

export default parseResolveError
